import axios from "@/utils/axios";
import wxWorkAxios from "@/utils/wxWorkAxios";

/**
 * 获取Sid
 * @param {*} params 
 * @returns 
 */
const getSid = async params => wxWorkAxios.get('/portal/r/jd?cmd=com.awspaas.user.apps.ryjy-sx_getSidByUid', params)

/**
* 通过企微id获取sid以及标识
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const getSidByQiWei = async (data, config) =>
  wxWorkAxios.post(
    "/portal/r/jd?cmd=com.awspaas.user.apps.ryjy-sx_getSidByQiWei",
    data,
    config,
  );

/**
* 保存
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const saveData = async (data, config) =>
  axios.post(
    "/employee_induction/employee_induction/saveDataEmployeeVo",
    data,
    {
      ...config,
    },
  );

/**
* 下一节点信息
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const queryNext = async (data, config) =>
  axios.post(
    "/employee_induction/employee_induction/queryNext",
    data,
    {
      ...config,
    },
  );

/**
* 提交
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const submitData = async (data, config) =>
  axios.post(
    "/employee_induction/employee_induction/commitTask",
    data,
    {
      ...config,
    },
  );

/**
* 获取省市信息
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const queryProvince = async (data, config) =>
  axios.post(
    "/employee_induction/employee_induction/queryProvince",
    data,
    {
      ...config,
    },
  );

/**
* 上传附件
* @param {*} params 
* @returns 
*/
const uploadFile = (params, config) =>
  wxWorkAxios.post(
    // "/portal/r/uf?repositoryName=myfile&appId=com.awspaas.user.apps.rygl",
    "/recruit/api/recruit/file/upload",
    params,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      ...config
    }
  );

/**
* 删除附件
* @param {*} params 
* @returns 
*/
const deleteFile = (params, config) =>
  wxWorkAxios.post(
    "/recruit/api/recruit/file/delete",
    params,
    {
      // headers: {
      //   "token":"123456",
      //   "Content-Type": "multipart/form-data"
      // },
      ...config
    }
  );

/**
* 获取企业信息列表
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const enterpriseList = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/enterprise/list",
    data,
    {
      ...config,
    },
  );

/**
* 企业简称模糊搜索
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const companyNameList = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/enterprise/companyNameList",
    data,
    {
      ...config,
    },
  );


const enterpriseAdd = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/enterprise/add",
    data,
    {
      ...config,
    },
  );

const enterpriseDelete = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/enterprise/delete",
    data,
    {
      ...config,
    },
  );

const enterpriseDetail = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/enterprise/detail",
    data,
    {
      requireAuth: false,
      ...config,
    },
  );

const managerDetail = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/enterprise/managerDetail",
    data,
    {
      ...config,
    },
  );

const checkDetail = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/enterprise/checkDetail",
    data,
    {
      ...config,
    },
  );

/**
* 添加修改平台封面
* @param {Object} data
* @param {Object} config
* @returns
*/
const savePicture = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/picture/addAndUpdatePicture",
    data,
    {
      ...config,
    },
  );

/**
* 获取平台封面
* @param {Object} data
* @param {Object} config
* @returns
*/
const queryPicture = async (data, config) =>
  axios.get("/recruit/api/recruit/picture/queryPictureList",
    data, {
    requireAuth: false,
    ...config,
  });


/**
* 删除平台封面
* @param {Object} data
* @param {Object} config
* @returns
*/
const deletePicture = async params => axios.post("/recruit/api/recruit/picture/deletePicture", params);

const enterpriseUpdate = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/enterprise/update",
    data,
    {
      ...config,
    },
  );

/**
* 
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const enterpriseUpdateCheck = async (data, config) =>
  axios.post("/recruit/api/recruit/enterprise/check", data, {
    ...config,
  });

/**
* 添加修改用户角色信息
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const addAndUpdateUser = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/user/addAndUpdateUser",
    data,
    {
      ...config,
    },
  );

/**
* 获取用户角色列表
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const getUserList = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/user/getUserList",
    data,
    {
      ...config,
    },
  );

/**
* 删除用户
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const removeUser = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/user/removeUser",
    data,
    {
      ...config,
    },
  );

/**
* 获取用户详情
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const getUserById = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/user/getUserById",
    data,
    {
      ...config,
    },
  );

/**
* 添加职位
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionAdd = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/add",
    data,
    {
      ...config,
    },
  );
/**
* 修改职位
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionUpadte = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/update",
    data,
    {
      ...config,
    },
  );

/**
* 获取职位列表
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionList = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/get/list",
    data,
    {
      ...config,
      diableGetAuth:true,
    },
  );

/**
* 企业职位页面，统计接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const companyAndPosition = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position//company/position",
    data,
    {
      ...config,
      diableGetAuth:true,
    },
  );

/**
* 企业职位页面，列表接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const companyPositionList = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/company/list",
    data,
    {
      ...config,
      diableGetAuth:true,
    },
  );

/**
* 获取企业招聘中的所有职位
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const companyPosition = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/companyPosition",
    data,
    {
      ...config,
    },
  );

/**
* 获取企业招聘中的所有职位
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const resetPassword = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/user/resetPassword",
    data,
    {
      ...config,
    },
  );

/**
* 获取企业招聘中的所有职位
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const deliverCompany = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/deliverCompany",
    data,
    {
      ...config,
    },
  );

/**
* 获取投递过的的所有职位
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const deliverPosition = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/deliverPosition",
    data,
    {
      ...config,
    },
  );


/**
* 获取职位详情
* @param {Object} data
* @param {Object} config
* @returns
*/
const positionDetail = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/get/",
    data,
    {
      ...config,
      requireAuth: false,
      
    },
  );

/**
* 获取职位类别
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionType = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/type",
    data,
    {
      requireAuth: false,
      ...config,
    },
  );

/**
* 获取发布过职位的职位类别
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const deliverPositionType = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/deliverType",
    data,
    {
      requireAuth: false,
      ...config,
    },
  );


/**
* 职位批量审批接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionCheck = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/check",
    data,
    {
      ...config,
    },
  );

/**
* 职位刷新接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionRefresh = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/refresh",
    data,
    {
      ...config,
    },
  );

/**
* 职位停止发布接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionStop = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/stop",
    data,
    {
      ...config,
    },
  );

/**
* 职位重新发布接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionRePublish = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/re-publish",
    data,
    {
      ...config,
    },
  );

/**
* 获取职位发布中的总数接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const positionCount = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/count",
    data,
    {
      ...config,
    },
  );

/**
* 获取城市接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const city = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/city",
    data,
    {
      requireAuth: false,
      ...config,
    },
  );

/**
* 获取发布过职位的城市接口
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const getDeliverCity = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/position/getDeliverCity",
    data,
    {
      requireAuth: false,
      ...config,
    },
  );

/**
* 模糊查询企业简称
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const enterpriseSimple = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/enterprise/companyNameList",
    params,
    {
      hideLoading: true,
      requireAuth: false,
      ...config,
    },
  );
/**
* 模糊查询用户
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const queryUser = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/user/all",
    params,
    {
      hideLoading: true,
      ...config,
    },
  );

  /**
* 模糊查询用户
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const getSystemUserId = async (params, config) =>
axios.get(
  "/recruit/api/recruit/user/getSystemUserId",
  params,
  {
    hideLoading: true,
    ...config,
  },
);



/**
* 查询用户信息
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const queryUserDetail = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/user/detail",
    params,
    config,
  );

/**
 * 用户退出
 * @param {Object} data
 * @param {Object} config
 * @returns
 */
const logout = async (params, config) =>
  axios.post("/recruit/api/user/logout", params, config);


/**
* 获取phoneToken
* @returns
*/
const phoneLogin = async (data, config) =>
  axios.post(
    "/recruit/api/user/phone/login",
    data,
    {
      ...config, requireAuth: false
    },
  );

/**
* 账号密码登陆获取Token
* @returns
*/
const accountLogin = async (data, config) =>
  axios.post(
    "/recruit/api/user/acc/login",
    data,
    {
      ...config, requireAuth: false
    },
  );

/**
* 获取p手机号验证码
* @returns
*/
const sendSms = async (data, config) =>
  axios.post(
    "/recruit/api/user/sms/send",
    data,
    {
      ...config, requireAuth: false
    },
  );


/**
* 投递记录
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const deliverRecord = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/position/deliver/record",
    params,
    config,
  );

/**
* 可投递职位列表
* @returns
*/
const deliverList = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/deliver/list",
    data,
    {
      ...config, 
      // requireAuth: false
      diableGetAuth:true
    },
  );
/**
* 添加我的简历
* @returns
*/
const addResume = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/add",
    data,
    config,
  );

/**
* 更新我的简历
* @returns
*/
const updateResume = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/update",
    data,
    config,
  );

/**
* 查询简历详情信息
* @param {Object} data
* @param {Object} config
* @returns
*/
const resumeDetail = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/resume/detail",
    params,
    {
      hideMsg: true,
      ...config
    },
  );



/**
* 投递职位
* @returns
*/
const deliver = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/deliver",
    data,
    {
      hideLoading: true,
      hideMsg: true,
      ...config
    },
  );


/**
* 查询投递简历列表
* @param {Object} data
* @param {Object} config
* @returns
*/
const deliverResumeList = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/position/deliver/resume",
    params,
    {
      ...config
    },
  );

/**
* 查询投递简历列表
* @param {Object} data
* @param {Object} config
* @returns
*/
const school = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/resume/school",
    params,
    {
      ...config
    },
  );

/**
* 查询投递简历列表
* @param {Object} data
* @param {Object} config
* @returns
*/
const major = async (params, config) =>
  axios.get(
    "/recruit/api/recruit/resume/major",
    params,
    {
      ...config
    },
  );

/**
* 查询投递简历列表
* @param {Object} data
* @param {Object} config
* @returns
*/
const findPeople = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/find",
    data,
    {
      ...config
    },
  );

/**
* 简历库简历列表
* @param {Object} data
* @param {Object} config
* @returns
*/
const resumeDatabase = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/resumeDatabase",
    data,
    {
      ...config
    },
  );

/**
* 简历库简历列表的记录总数
* @param {Object} data
* @param {Object} config
* @returns
*/
const resumeDatabasePage = async (data, config) =>
  axios.post(
    "recruit/api/recruit/resume/resumeDatabasePage",
    data,
    {
      hideLoading: true,
      ...config
    },
  );

/**
* 下载简历
* @returns
*/
const downloadResumeDatabase = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/downloadResumeDatabase",
    data,
    {
      ...config
    },
  );

/**
* 下载简历
* @returns
*/
const exportResumeDatabase = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/exportResumeDatabase",
    data,
    {
      ...config
    },
  );

/**
* 下载简历
* @returns
*/
const downloadFind = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/downloadFind",
    data,
    {
      ...config
    },
  );

/**
* 导出职位信息
* @returns
*/
const exportPosition = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/company/list/download",
    data,
    {
      ...config
    },
  );

/**
* 下载简历
* @returns
*/
const downloadFindFlag = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/downloadFindFlag",
    data,
    {
      ...config
    },
  );

/**
* 下载简历
* @returns
*/
const downloadResume = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/download",
    data,
    {
      ...config
    },
  );

/**
* 导出简历数据
* @returns
*/
const exportResume = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/resume/export",
    data,
    {
      ...config
    },
  );

/**
* 导出企业数据
* @returns
*/
const exportCompany = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/enterprise/export",
    data,
    {
      ...config
    },
  );

/**
* 导出用户角色数据
* @returns
*/
const exportUser = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/user/export",
    data,
    {
      ...config
    },
  );

/**
* 签署三方协议
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const signResume = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/resume/sign",
    data,
    {
      ...config,
    },
  );

/**
* 转入简历库
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const transferResume = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/resume/transfer",
    data,
    {
      ...config,
    },
  );

/**
* 签署三方协议
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const revokeResume = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/resume/revoke",
    data,
    {
      ...config,
    },
  );

/**
* 注销账户
* @param {Object} data 
* @param {Object} config 
* @returns 
*/
const cancellation = async (data, config) =>
  axios.get(
    "/recruit/api/user/cancellation",
    data,
    {
      ...config,
    },
  );

/**
 * 获取图片验证码接口
 * @param {Object} data 
 * @param {Object} config 
 * @returns 
 */
  const getImgCode = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/common/captcha-image",
    data,
    {
      requireAuth: false,
      hideLoading: true,
      ...config,
    },
  );

  /**
* 修改密码
* @returns
*/
const updatePassword = async (data, config) =>
axios.post(
  "/recruit/api/recruit/user/updatePassword",
  data,
  {
    ...config
  },
);

  /**
* 忘记密码
* @returns
*/
const retrievePassword = async (data, config) =>
axios.post(
  "/recruit/api/recruit/user/forgetPassword",
  data,
  {
    requireAuth: false,
    ...config
  },
);

  /**
* 修改信息
* @returns
*/
const userupdateUser = async (data, config) =>
axios.post(
  "/recruit/api/recruit/user/updateUser",
  data,
  {
    ...config
  },
);

/**
* 添加敏感词
* @returns
*/
const sensitiveAdd = async (data, config) =>
axios.post(
  "/recruit/api/recruit/sensitive/add",
  data,
  {
    ...config
  },
);

/**
* 删除敏感词
* @returns
*/
const sensitiveDelete = async (data, config) =>
axios.get(
  "/recruit/api/recruit/sensitive/delete",
  data,
  {
    ...config
  },
);

/**
* 查询敏感词列表
* @returns
*/
const sensitiveList = async (data, config) =>
axios.get(
  "/recruit/api/recruit/sensitive/list",
  data,
  {
    ...config
  },
);

/**
* 获取是否可以添加职位标识
* @returns
*/
const addPositionFlag = async (data, config) =>
axios.get(
  "/recruit/api/recruit/enterprise/addPositionFlag",
  data,
  {
    ...config
  },
);

/**
* 获取简历是否已读
* @returns
*/
const readResumeFlag = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/resume/readResumeFlag",
    data,
    {
      ...config
    },
  );

/**
* 企业信息审核退回
* @returns
*/
const enterpriseRollback = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/enterprise/rollback",
    data,
    {
      ...config
    },
  );

/**
* 职位审核退回
* @returns
*/
const positionRollback = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/position/rollback",
    data,
    {
      ...config
    },
  );

/**
* 历年数据列表
* @returns
*/
const countList = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/count/list",
    data,
    {
      ...config
    },
  );

/**
* 历年数据导出
* @returns
*/
const countExport = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/count/export",
    data,
    {
      isBlob: true,
      ...config
    },
  );

/**
* 清除实习简历
* @returns
*/
const countClearResume = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/count/clearResume",
    data,
    {
      ...config
    },
  );

/**
* 招聘时间列表
* @returns
*/
const countsSchoolDateList = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/count/schoolDateList",
    data,
    {
      ...config
    },
  );

/**
* 添加校招时间
* @returns
*/
const countsAddSchoolDate = async (data, config) =>
  axios.post(
    "/recruit/api/recruit/count/addSchoolDate",
    data,
    {
      ...config
    },
  );

/**
* 添加校招时间
* @returns
*/
const resumeWorkCompany = async (data, config) =>
  axios.get(
    "/recruit/api/recruit/resume/workCompany",
    data,
    {
      ...config
    },
  );

export default {
  getSid,
  getSidByQiWei,
  saveData,
  queryNext,
  submitData,
  queryProvince,
  uploadFile,
  deleteFile,
  enterpriseList,
  companyNameList,
  enterpriseAdd,
  enterpriseDelete,
  enterpriseDetail,
  managerDetail,
  checkDetail,
  enterpriseUpdate,
  enterpriseUpdateCheck,
  enterpriseSimple,
  savePicture,
  queryPicture,
  deletePicture,
  addAndUpdateUser,
  getUserList,
  removeUser,
  getUserById,
  positionAdd,
  positionUpadte,
  positionList,
  companyAndPosition,
  companyPositionList,
  companyPosition,
  deliverPosition,
  deliverCompany,
  positionDetail,
  positionType,
  deliverPositionType,
  positionCheck,
  positionRefresh,
  positionStop,
  positionRePublish,
  positionCount,
  city,
  getDeliverCity,
  queryUser,
  getSystemUserId,
  queryUserDetail,
  logout,
  phoneLogin,
  accountLogin,
  sendSms,
  deliverRecord,
  deliverList,
  deliver,
  addResume,
  updateResume,
  resumeDetail,
  school,
  major,
  deliverResumeList,
  findPeople,
  resumeDatabase,
  resumeDatabasePage,
  downloadResumeDatabase,
  exportResumeDatabase,
  downloadFind,
  exportPosition,
  downloadFindFlag,
  downloadResume,
  exportResume,
  exportCompany,
  exportUser,
  signResume,
  transferResume,
  revokeResume,
  cancellation,
  getImgCode,
  updatePassword,
  retrievePassword,
  resetPassword,
  userupdateUser,
  sensitiveAdd,
  sensitiveDelete,
  sensitiveList,
  addPositionFlag,
  readResumeFlag,
  enterpriseRollback,
  positionRollback,
  countList,
  countExport,
  countClearResume,
  countsSchoolDateList,
  countsAddSchoolDate,
  resumeWorkCompany,
};
